import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import Swal from "sweetalert2";

function UserUpdateModal({ title, onClose, id, originRows, handleView, deptModalOption, workplaceModalOption, positionModalOption, dutyModalOption, bankModalOption, MenuUpdateYN }) {
  const appStore = useContext(AppContext);
  const userNameRef = useRef(null);
  const [isPhoneDisabled, setIsPhoneDisabled] = useState(false);
  const [inputs, setInputs] = useState({
    user_id:0,
    workplace_id: 0,
    dept_id:0,
    duty:0,
    position:0,
    bank:0,
    user_login_id:'',
    emp_no:'',
    user_call:'',
    user_email:'',
    user_name:'',
    user_phone:'',
    user_start_date: '',
    user_end_date: '',
    bank_number: '',
    user_note: ''
  });
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  useEffect(() => {
      // Mount 될때만 실행된다.
      userNameRef.current.focus();
  }, []);

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  const handleInitSelect = () => {
    setInputs({
      user_login_id: originRows[0].user_login_id,
      dept_id: (typeof originRows[0].dept_id === 'undefined')? 0:originRows[0].dept_id,
      duty: (typeof originRows[0].duty === 'undefined')? 0:originRows[0].duty,
      emp_no: originRows[0].emp_no,
      position: (typeof originRows[0].position === 'undefined')? 0:originRows[0].position,
      user_call: originRows[0].user_call,
      user_email: originRows[0].user_email,
      user_id: originRows[0].user_id,
      user_name: originRows[0].user_name,
      user_phone: originRows[0].user_phone,
      user_status: originRows[0].user_status,
      workplace_id: (typeof originRows[0].workplace_id === 'undefined')? 0:originRows[0].workplace_id,
      bank: (typeof originRows[0].user_account_bank === 'undefined')? 0:originRows[0].user_account_bank,
      bank_number: originRows[0].user_account_number,
      user_note: originRows[0].user_note,
      user_start_date: originRows[0].user_start_date,
      user_end_date: originRows[0].user_end_date
    });
  };

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = async (e) => {
    const {name, value} = e.target;
    var hyphen_data = ''
    hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
    if (hyphen_data.match(/010-(\d{4})-(\d{4})/)) {
      Swal.fire({
          title: '휴대폰인증',
          html : hyphen_data + ' 인증번호를 발송 할까요?',
          showCancelButton : true,
          confirmButtonClass : "btn-danger",
          confirmButtonText : "확인",
          cancelButtonText : "취소"
      }).then((result) => {
          if (result.isConfirmed) {
              var returndata = appStore.PHONE_AUTH(hyphen_data);
              if(String(returndata) === 'Y'){
                setIsPhoneDisabled(true);
              }
          }
      });
    }
  };

  const handleSave = () => {
    // 이름 확인 정규식(2-20 자리 영문소+영문대+한글+띄어쓰기 입력 가능) : !(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())
    // 날짜 확인 정규식(19@@년도 입력 불가) : !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 날짜 확인 정규식(19@@년도 입력 가능) : !(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 휴대폰 정규식(010-숫자4자리-숫자4자리 입력 가능) : !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())
    // 전화번호 정규식(숫자3자리-숫자4자리-숫자4자리) : !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())
    // E-Mail 정규식 : !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())
    // 계좌번호 정규식(숫자, 하이픈 5-30자리 이하) : !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())
    let msg = '';
    if(inputs.user_name.trim() === ''){
      msg = '이름은 필수로 입력 해주세요.';
    }else if(!(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())){
      msg = '이름 입력이 올바르지 않습니다.<br/>(입력 양식 : 한글+영문+띄어쓰기 2~20자리)';
    }else if(inputs.workplace_id === 0){
      msg = '사업장은 필수로 선택 해주세요.';
    }else if(inputs.dept_id === 0){
      msg = '부서는 필수로 선택 해주세요.';
    }else if(inputs.position === 0){
      msg = '직위는 필수로 선택 해주세요.';
    }else if(inputs.duty === 0){
      msg = '직책은 필수로 선택 해주세요.';
    }else if(inputs.user_start_date.trim() === ''){
      msg = '입사일자는 필수로 입력 해주세요.';
    }else if(!(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())){
      msg = '입사일자 입력이 올바르지 않습니다.';
    }else if(inputs.user_end_date.trim() !== '' && !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_end_date.trim())){
      msg = '퇴사일자 입력이 올바르지 않습니다.';
    }else if(inputs.user_phone.trim() !== '' && !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())){
      msg = '휴대폰번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자4자리-숫자4자리)';
    }else if(inputs.user_call.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())){
      msg = '전화번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자3자리-숫자4자리-숫자4자리)';
    }else if(inputs.user_email.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())){
      msg = 'E-Mail 입력이 올바르지 않습니다.';
    }else if(inputs.emp_no.trim() !== '' && inputs.emp_no.trim().length > 20){
      msg = '사번 입력이 올바르지 않습니다.<br/>(입력 양식 : 20자리 이하)';
    }else if(inputs.bank_number.trim() !== '' && !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())){
      msg = '계좌번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자, 하이픈 5자리~30자리)';
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/User/Update", new URLSearchParams({
        update_user_id: id,
        user_name: inputs.user_name.trim(),
        workplace_id: inputs.workplace_id,
        dept_id: inputs.dept_id,
        position: inputs.position,
        duty: inputs.duty,
        emp_no: inputs.emp_no.trim(),
        user_email: inputs.user_email.trim(),
        user_phone: inputs.user_phone.trim(),
        user_call: inputs.user_call.trim(),
        bank: inputs.bank,
        bank_number: inputs.bank_number.trim(),
        user_start_date: inputs.user_start_date.trim(),
        user_end_date: inputs.user_end_date.trim(),
        user_note: inputs.user_note.trim()
     }),
     { withCredentials: true })
     .then(function (response) {
         if(response.status === 200){
          Swal.fire({
            title: '사용자 수정 완료',
            text: '정상적으로 사용자가 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleInitSelect();
            handleView();
          });
         }else{
          appStore.capture();
         }
     })
     .catch(function (error) {
         appStore.capture();
     })
     .finally(() => {
       appStore.setLoading(false); 
     });
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">사용자 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  const handlePWReset = () => {
    if (appStore.loading) return;
    appStore.setLoading(true);
    
    axios.post("/api/p/User/PWReset", new URLSearchParams({
      update_user_id: id
   }),
   { withCredentials: true })
    .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '사용자 비밀번호 초기화 완료',
            text: '정상적으로 비밀번호가 초기화 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleInitSelect();
            handleView();
          });
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
    })
    .finally(() => {
      appStore.setLoading(false); 
    });
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '615px', overflowY: 'auto'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">이름<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="이름" value={inputs.user_name} name="user_name" onChange={(e) => onChange(e) } ref={userNameRef} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">로그인ID<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="로그인ID" value={inputs.user_login_id} name="user_login_id" onChange={(e) => onChange(e) } disabled style={ { fontWeight:'bold', color: 'black' } } />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">사업장<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="사업장" value={workplaceModalOption.filter(function (option) { return option.value === inputs.workplace_id;  })} onChange={(e) => onSelectChange('workplace_id',e.value)} options={workplaceModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">부서<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="부서" value={deptModalOption.filter(function (option) { return option.value === inputs.dept_id;  })} onChange={(e) => onSelectChange('dept_id',e.value)} options={deptModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">직위<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="직위" value={positionModalOption.filter(function (option) { return option.value === inputs.position;  })} onChange={(e) => onSelectChange('position',e.value)} options={positionModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">직책<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="직책" value={dutyModalOption.filter(function (option) { return option.value === inputs.duty;  })} onChange={(e) => onSelectChange('duty',e.value)} options={dutyModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">사번</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="사번" value={inputs.emp_no} name="emp_no" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">E-mail</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="E-mail" value={inputs.user_email} name="user_email" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">휴대폰번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="휴대폰번호" value={inputs.user_phone} name="user_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" disabled={isPhoneDisabled} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">전화번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="전화번호" value={inputs.user_call} name="user_call" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">은행</div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="은행" value={bankModalOption.filter(function (option) { return option.value === inputs.bank;  })} onChange={(e) => onSelectChange('bank',e.value)} options={bankModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">계좌번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="계좌번호" value={inputs.bank_number} name="bank_number" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">입사일자<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="date" placeholder="입사일자" value={inputs.user_start_date} name="user_start_date" onChange={(e) => onChange(e) } />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">퇴사일자</div>
                      <div className="modal_filed_input">
                        <input type="date" placeholder="퇴사일자" value={inputs.user_end_date} name="user_end_date" onChange={(e) => onChange(e) } />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">비고</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="비고" value={inputs.user_note} name="user_note" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      {updateFlag &&
                      <div className="modal_button" style={{float: 'left'}}>
                        <Button 
                          onClick={ handlePWReset }
                          className="btn-p btn-u"
                          style={{width: '170px'}}
                          sx={{  
                              m: 1, 
                              fontSize: 18, 
                              color: "white", 
                              borderColor: "#0067a3", 
                              backgroundColor: "#0067a3",
                              ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                          }} 
                          variant="outlined">
                          비밀번호 초기화
                        </Button>
                      </div>
                      }

                      <div className="modal_button">
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                      {updateFlag &&
                      <div className="modal_button">
                        <Button 
                          onClick={handleSave}
                          className="btn-p btn-u"
                          sx={{  
                              m: 1, 
                              fontSize: 18, 
                              color: "white", 
                              borderColor: "#FF3636", 
                              backgroundColor: "#FF3636",
                              ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                          }} 
                          variant="outlined">
                          수정
                        </Button>
                      </div>
                      }
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default UserUpdateModal;